import { createI18nText } from '../../functions';
var searchInputText = createI18nText({
    he: {
        search: 'חיפוש'
    },
    en: {
        search: 'Search'
    }
});
export default searchInputText;
//# sourceMappingURL=searchInputText.js.map